// extracted by mini-css-extract-plugin
export var container = "_2c-0";
export var icon = "_2c-1";